<template>
    <div>
        <label for="password" class="font-medium text-primary dark:text-white" :class="label_class">{{ label }}</label>
        <input
            :name="name"
            :placeholder="placeholder"
            :value="modelValue"
            :class="input_class"
            :id="id"
            @input="$emit('update:modelValue', $event.target.value)" 
            type="password"
            class="block w-full flex-1 border border-primary dark:border-white rounded-md px-3 py-2 text-primary dark:text-white placeholder:text-primary dark:placeholder:text-white focus:outline-none focus:bg-light-100 dark:focus:bg-dark-900 sm:text-sm sm:leading-6 bg-white dark:bg-dark-900">
    </div>
</template>

<script>
export default {
    name: 'InputPassword',
    props: {
        label: String,
        label_class: String,
        id: String,
        name: String,
        placeholder: String,
        modelValue: String,
        input_class: String
    },
    emits: ['update:modelValue'],
}
</script>